import React, {useEffect } from "react";
import { ChevronLeft } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import apilink from "../globals/Baseurls";
import axios from "axios";
import "react-activity/dist/library.css";

const MemberContributions = () => {
  const navigate = useNavigate();
  const [contributions, setContributions] = React.useState([]);

  useEffect(() => {
    const getAsyncData = async () => {
        const familyData = await JSON.parse(
            localStorage.getItem("userFamilyData")
          );

        

      //Today
      const baseUrl = apilink.link;
      await axios
        .get(`${baseUrl}/family/admin/contris/${familyData.record.familycode}`, {
          headers: {
            "Content-Type": "application/json",
          },
        })

        .then((response) => {
          if (response.data.message == "Successfull") {
            setContributions(response.data.records);
          }
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    };
    getAsyncData();
  }, []);
  return (
    <div>
      <div
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#779d38",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <h4 onClick={()=>navigate("/app/more")} style={{ fontFamily: "Open Sans", fontSize: 17 }}>
          <ChevronLeft size={20} style={{ color: "#ffffff" }} />
        </h4>
        <h4 style={{ fontFamily: "Open Sans", fontSize: 17, color: "#ffffff" }}>
          <b>More /</b> Expected Contributions
        </h4>
      </div>

      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "17px",
        }}
      >
        <div
          style={{
            alignItems: "center",
            paddingInline: "10px",
            marginTop: "10px",
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#779d3820",
            height: "50px",
            marginBottom: "40px",
            width: "100%",
            borderRadius: "5px",
          }}
        >
          <h4
            style={{ fontFamily: "Open Sans", fontSize: 20, color: "#779d38" }}
          >
            Saved Contributions ({contributions.length})
          </h4>
        </div>
        {contributions.map((record) => (
          <div
            key={record.id}
          
            style={{ flexDirection: "column", marginBottom: "30px" }}
          >
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h6 style={{ fontFamily: "Open Sans", fontWeight: "bold" }}>
                  {record.theme}
                </h6>
                <h6 style={{ fontFamily: "Open Sans" }}>
                  <b>Notes:</b> {record.notes == null ? "---" : record.notes}
                </h6>
              </div>
              <div>
                <span className="float-end" style={{ fontFamily: "Open Sans" }}>
                  <b>End Date: </b> {record.enddate}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default MemberContributions;
